import React from "react";

import {
  BarChart,
  Bar,
  CartesianGrid,
  ResponsiveContainer,
  XAxis,
  YAxis,
  Tooltip,
  TooltipProps,
} from "recharts";

interface CustomTooltipProps extends TooltipProps<number, string> {}

const CustomTooltip: React.FC<CustomTooltipProps> = ({
  active,
  payload,
  label,
}) => {
  if (active && payload && payload.length) {
    return (
      <div
        className="custom-tooltip px-3"
        style={{
          backgroundColor: "rgb(39, 40, 53)",
          color: "white",

          border: "1px solid rgb(39, 40, 53)",
          borderRadius: "5px",
        }}
      >
        <p
          className="label p-2"
          style={{ fontSize: "14px", borderBottom: "1px solid gray" }}
        >{`${label}`}</p>

        <div className="flex flex-col gap-2 py-2.5">
          <div className="flex flex-row gap-6">
            <div className="flex items-center space-x-2">
              <div className="w-4 h-4 rounded-full border-4 border-black"></div>
              <div className="text-xs">
                {/* 426 */}
                {`${payload[0].value}`}
              </div>
            </div>
            <div className="flex items-center">
              <svg
                width="18"
                height="19"
                viewBox="0 0 12 13"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M2.22656 6.14787C2.27882 6.20031 2.34092 6.24191 2.40929 6.2703C2.47766 6.2987 2.55097 6.31331 2.625 6.31331C2.69903 6.31331 2.77234 6.2987 2.84071 6.2703C2.90908 6.24191 2.97118 6.20031 3.02344 6.14787L5.43703 3.73427V10.6249C5.43703 10.7741 5.4963 10.9172 5.60178 11.0226C5.70727 11.1281 5.85035 11.1874 5.99953 11.1874C6.14872 11.1874 6.29179 11.1281 6.39728 11.0226C6.50277 10.9172 6.56203 10.7741 6.56203 10.6249V3.73427L8.97656 6.14787C9.08224 6.25354 9.22556 6.3129 9.375 6.3129C9.52444 6.3129 9.66777 6.25354 9.77344 6.14787C9.87911 6.04219 9.93848 5.89887 9.93848 5.74943C9.93848 5.59999 9.87911 5.45666 9.77344 5.35099L6.39844 1.97599C6.34618 1.92355 6.28408 1.88194 6.21571 1.85355C6.14734 1.82516 6.07403 1.81055 6 1.81055C5.92597 1.81055 5.85266 1.82516 5.78429 1.85355C5.71592 1.88194 5.65382 1.92355 5.60156 1.97599L2.22656 5.35099C2.17412 5.40325 2.13251 5.46535 2.10412 5.53372C2.07573 5.60209 2.06112 5.6754 2.06112 5.74943C2.06112 5.82346 2.07573 5.89677 2.10412 5.96514C2.13251 6.03351 2.17412 6.09561 2.22656 6.14787Z"
                  fill="#40C4AA"
                />
              </svg>
              <div className="text-xs">16.2%</div>
            </div>
          </div>
          <div className="flex justify-between">
            <div className="flex items-center space-x-2">
              <div className="w-4 h-4 rounded-full border-4 border-divBlue"></div>
              <div className="text-xs">
                {/* 1,256 */}
                {`${payload[1].value}`}
              </div>
            </div>
            <div className="flex items-center">
              <svg
                width="18"
                height="19"
                viewBox="0 0 12 13"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M9.77344 6.85213C9.72118 6.79969 9.65908 6.75809 9.59071 6.7297C9.52234 6.7013 9.44903 6.68669 9.375 6.68669C9.30097 6.68669 9.22766 6.7013 9.15929 6.7297C9.09092 6.75809 9.02882 6.79969 8.97656 6.85213L6.56297 9.26573V2.3751C6.56297 2.22592 6.5037 2.08284 6.39822 1.97736C6.29273 1.87187 6.14965 1.8126 6.00047 1.8126C5.85128 1.8126 5.70821 1.87187 5.60272 1.97736C5.49723 2.08284 5.43797 2.22592 5.43797 2.3751V9.26573L3.02344 6.85213C2.91776 6.74646 2.77444 6.6871 2.625 6.6871C2.47556 6.6871 2.33223 6.74646 2.22656 6.85213C2.12089 6.95781 2.06152 7.10113 2.06152 7.25057C2.06152 7.40001 2.12089 7.54334 2.22656 7.64901L5.60156 11.024C5.65382 11.0764 5.71592 11.1181 5.78429 11.1464C5.85266 11.1748 5.92597 11.1895 6 11.1895C6.07403 11.1895 6.14734 11.1748 6.21571 11.1464C6.28408 11.1181 6.34618 11.0764 6.39844 11.024L9.77344 7.64901C9.82588 7.59675 9.86749 7.53465 9.89588 7.46628C9.92427 7.39791 9.93888 7.3246 9.93888 7.25057C9.93888 7.17654 9.92427 7.10323 9.89588 7.03486C9.86749 6.96649 9.82588 6.90439 9.77344 6.85213Z"
                  fill="#ED8296"
                />
              </svg>

              <div className="text-xs">32.5%</div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return null;
};

const data = [
  {
    name: "JAN",
    inflow: 40000,
    outflow: 24000,
    amt: 2400,
  },
  {
    name: "FEB",
    inflow: 30000,
    outflow: 43958,
    amt: 2210,
  },
  {
    name: "MAR",
    inflow: 20000,
    outflow: 28101,
    amt: 2290,
  },
  {
    name: "APR",
    inflow: 27800,
    outflow: 37780,
    amt: 2000,
  },
  {
    name: "MAY",
    inflow: 18900,
    outflow: 48009,
    amt: 2181,
  },
  {
    name: "JUN",
    inflow: 23900,
    outflow: 38476,
    amt: 2500,
  },
  {
    name: "JUL",
    inflow: 34900,
    outflow: 34000,
    amt: 2100,
  },
  {
    name: "AUG",
    inflow: 50000,
    outflow: 43000,
    amt: 2100,
  },
  {
    name: "SEP",
    inflow: 18900,
    outflow: 48009,
    amt: 2181,
  },
  {
    name: "OCT",
    inflow: 23900,
    outflow: 38476,
    amt: 2500,
  },
  {
    name: "NOV",
    inflow: 34900,
    outflow: 34000,
    amt: 2100,
  },
  {
    name: "DEC",
    inflow: 50000,
    outflow: 43000,
    amt: 2100,
  },
];

const BarGraph = () => {
  return (
    <div className="h-[350px] ">
      <ResponsiveContainer width="100%" height="100%">
        <BarChart width={150} height={40} data={data}>
          <CartesianGrid vertical={false} />
          <XAxis dataKey="name" tick={{ fontSize: 12 }} />
          <YAxis
            domain={[0, 50000]}
            tickCount={6}
            tickFormatter={(value) => `${value / 1000}K`}
            tick={{ fontSize: 12 }}
          />
          <Tooltip
            content={<CustomTooltip />}
            cursor={{ fill: "transparent" }}
          />
          <Bar
            dataKey="inflow"
            fill="rgb(102, 161, 255)"
            radius={[3, 3, 3, 3]}
          />
          <Bar dataKey="outflow" fill="rgb(26, 27, 37)" radius={[3, 3, 3, 3]} />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default BarGraph;
